import { render, staticRenderFns } from "./BoschZone.vue?vue&type=template&id=1b47d972&scoped=true"
import script from "./BoschZone.vue?vue&type=script&lang=js"
export * from "./BoschZone.vue?vue&type=script&lang=js"
import style0 from "./BoschZone.vue?vue&type=style&index=0&id=1b47d972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47d972",
  null
  
)

export default component.exports